export default "__VITE_ASSET__e8b911ce__"